var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useQueryContext } from '@sierralabs/query-ui';
export const SiteQueryFieldPicker = props => {
    const { queryId, queryField, variant, multiple, hideQueryName, onChange } = props, textFieldProps = __rest(props, ["queryId", "queryField", "variant", "multiple", "hideQueryName", "onChange"]);
    const { queries } = useQueryContext();
    const options = (props.options || queries).reduce((options, query) => {
        var _a;
        const all = (((_a = query.config) === null || _a === void 0 ? void 0 : _a.selects) || []).map(select => {
            return { query, selection: select.selection };
        });
        options.push(...all);
        return options;
    }, []);
    const values = options.filter(option => {
        return (option.query.id === queryId &&
            (Array.isArray(queryField)
                ? queryField.includes(option.selection)
                : option.selection === queryField));
    });
    const value = multiple ? values : values[0] || null;
    const additionalInputProps = {};
    if (!variant)
        additionalInputProps.disableUnderline = true;
    return (React.createElement(Autocomplete, { fullWidth: true, value: value, options: options, multiple: multiple, getOptionLabel: option => {
            return hideQueryName
                ? option.selection
                : `${option.query.name} -> ${option.selection}`;
        }, onChange: (_, option) => {
            var _a, _b;
            const allOptions = Array.isArray(option)
                ? option
                : option
                    ? [option]
                    : [];
            const options = allOptions.map(option => {
                return { queryId: option.query.id, queryField: option.selection };
            });
            if (props.multiple) {
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, options);
            }
            else {
                (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, options[0] || {});
            }
        }, renderInput: params => (React.createElement(TextField, Object.assign({ variant: variant }, params, { fullWidth: true, size: 'small', placeholder: 'Pick a Query Field' }, textFieldProps, { InputProps: Object.assign(Object.assign(Object.assign({}, params.InputProps), textFieldProps.InputProps), additionalInputProps), InputLabelProps: Object.assign(Object.assign({}, params.InputLabelProps), textFieldProps.InputLabelProps) }))) }));
};
export default SiteQueryFieldPicker;
//# sourceMappingURL=SiteQueryFieldPicker.js.map